let eventHandlers = {};
export default {
  addEventHandler(eventType, eventHandler) {
    let handlers = eventHandlers[eventType];
    if (!handlers) {
      handlers = [];
      eventHandlers[eventType] = handlers;
    }
    let registeredHandler = handlers.find((h) => h === eventHandler);
    if (!registeredHandler) {
      handlers.push(eventHandler);
      // console.log('addEventHandler for eventType', eventType);
    }
  },
  removeEventHandler(eventType, eventHandler) {
    let handlers = eventHandlers[eventType];
    if (handlers) {
      for (var i = handlers.length - 1; i >= 0; i--) {
        if (handlers[i] === eventHandler) {
          handlers.splice(i, 1);
        }
      }
    }
    // console.log('removeEventHandler for eventType', eventType);
  },

  /**
   * Send an event to all handlers except self
   * @param {Function} selfHandler - this argument must be provided, when the sender has an own handler for the same eventType. 
   *                                 Thus it is avoided to receive the event back. 
   *                                 Optional argument.
   * @param {String} eventType - the event type or identifier
   * @param {Object} eventObj - arbitrary event object
   */
  publish({selfHandler, eventType, eventObj}) {
    let handlers = eventHandlers[eventType];
    if (handlers) {
      handlers.forEach((handler) => {
        if (handler !== selfHandler) {
          handler(eventType, eventObj);
        }
      });
    }
  },

  /**
   * Creates a FileChangedEventType identifier to be used for registration and publishing
   * @param {Object} item - the item with at least a ._moduleId and .id property
   * @returns the eventType 
   */
  createFileChangedEventType(item) {
    return `FCE_${item._moduleId}_${item.id}`;
  },

   /**
   * Creates a ReadStateEventType identifier to be used for registration and publishing
   * @param {Object} item - the item with at least a ._moduleId and .id property
   * @returns the eventType 
   */
    createReadStateEventType(item) {
        return `RSE_${item._moduleId}_${item.id}`;
      },
};
